import { gql } from "@apollo/client"

export const UpdateProduct = gql`
mutation Mutation($updateProductId: ID!, $content: contentProduct!) {
  updateProduct(id: $updateProductId, content: $content) {
    status
  }
}
`